'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIApplication;

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _setupStyledComponents = require('../listeners/setupStyledComponents');

var _ComponentWithBodyClass = require('../utils/ComponentWithBodyClass');

var _ComponentWithBodyClass2 = _interopRequireDefault(_ComponentWithBodyClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function UIApplication(props) {
  var _bodyElement = props._bodyElement,
      bodyClassName = props.bodyClassName,
      name = props.name,
      rest = _objectWithoutProperties(props, ['_bodyElement', 'bodyClassName', 'name']);

  (0, _react.useEffect)(_setupStyledComponents.setupStyledComponents, []);

  return _react2.default.createElement(
    _ComponentWithBodyClass2.default,
    {
      bodyClassName: (0, _classnames2.default)('ui-app', bodyClassName),
      bodyElement: _bodyElement
    },
    _react2.default.createElement('div', _extends({ 'data-application-name': name }, rest))
  );
}

UIApplication.propTypes = {
  _bodyElement: _propTypes2.default.object,
  bodyClassName: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired
};

UIApplication.displayName = 'UIApplication';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/app/UIApplication.js
// module id = 194
// module chunks = 177